import React from 'react';
import './Landing.css';
import { cognitoConfig } from '../LoginPage/config';

const Landing = () => {

  const handleLogin = () => {
    const { Domain, Region, ClientId, IdentityProvider, RedirectUriSignIn } = cognitoConfig;
    const authUrl = `https://${Domain}.auth.${Region}.amazoncognito.com/oauth2/authorize`
      + `?response_type=code`
      + `&client_id=${ClientId}`
      + `&redirect_uri=${encodeURIComponent(RedirectUriSignIn)}`
      + `&identity_provider=${IdentityProvider}`;
    window.location.href = authUrl;
  };

  return (
    <div className="landing-container">
      <div className="landing-content">
        <div className="landing-logo">
          <div className="logo-box">DXI</div>
          <h1 className="landing-title">TinyManager</h1>
        </div>
        <button className="login-button" onClick={handleLogin}>
          Login with KONE account
        </button>
        <p className="landing-footer">Secure access management system</p>
      </div>
    </div>
  );
};

export default Landing;